<template>
  <div class="quiz-start quiz-intro">
    <div class="quiz-description col-sm-auto">
      <!--    {{quiz.description}}-->
      <div class="header mb-4">
        <div class="header__wrapper">
          <div class="header__title">
            <h1 v-if="quiz.title" class="quiz-description__title" v-html="quiz.title"></h1>
          </div>
          <div class="header__logo">
            <img :src="require('@/assets/images/logo-polki25-1-trimmed.png')"
                 alt="Polki25 Logo" class="img-responsive" />
          </div>
        </div>
      </div>
      <!-- eslint-disable -->
      <div v-if="!quiz.testDevMode" class="quiz-description__content">
        <h3 class="quiz-description__content-title">
          W ramach odetchnięcia po raporcie poznaj nasze superbohaterki.
        </h3>
        <p class="quiz-description__content-subtitle">
          Segmentacja ilościowa wyłoniła PIĘĆ wyraźnych segmentów POLEK.<br/>
          Wypełnij krótki Quiz, sprawdź do którego segmentu należysz i dowiedz się jakie są jego kluczowe cechy i postawy.
        </p>
      </div>

      <start1 v-if="numStartPage === 1"
              :numStartPage="numStartPage"
              @nextStartPage="$emit('nextStartPage')"
      />
      <start2 v-if="numStartPage === 2"
              :numStartPage="numStartPage"
              @nextStartPage="$emit('nextStartPage')"
      />
      <start3 v-if="numStartPage === 3"
              :numStartPage="numStartPage"
              @nextStartPage="$emit('nextStartPage')"
      />
      <!-- eslint-enable -->
    </div>

    <div class="quiz-nav text-center mb-5">
      <p>
        Możesz użyć myszki, klawiszy 1-5 lub wskazać na ekranie
      </p>

      <button class="btn btn-primary btn-quiz-start" @click="$emit('start')">
        {{ $t('start_quiz') }}
      </button>
    </div>
  </div>
</template>

<script>
import Start1 from '@/views/start/Start1.vue';
import Start2 from '@/views/start/Start2.vue';
import Start3 from '@/views/start/Start3.vue';

export default {
  name: 'Start',
  components: { Start3, Start2, Start1 },
  props: ['quiz', 'numStartPage', 'nextStartPage'],
};
</script>

<style scoped>
.quiz-description {
  text-align: center;
}

.quiz-description__content-title,
.quiz-description__content-subtitle {
  margin-bottom: 20px;
}

.btn-quiz-start {
  margin-top: 10px;
  height: 2rem;
  padding: 2em 3em !important;
  line-height: 0.2em !important;
  background: var(--color-project-gradient-from);
  color: var(--color-project-text);
  border-radius: 900px;
}

.btn-quiz-start:hover,
.btn-quiz-start:focus {
  background: var(--color-project-primary);
}

.header {
  padding: 3em 3em;
  display: flex;
  justify-content: start;
  background: url('~@/assets/images/main-banner-logo-on-right.png') center center no-repeat;
  background-size: cover;
}
.header__wrapper {
  width: 700px !important;
  max-width: 90vw;
  display: flex;
  flex-wrap: nowrap;
  background: #fff;
  border-radius: 30px;
  overflow: hidden;
}
.header__title {
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(0deg, var(--color-project-gradient-from) 0%,
    var(--color-project-gradient-to) 100%);
}
.header__title h1 {
  margin: 0;
  color: var(--color-system-primary);
}

.header__logo {
  padding: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quiz-description__title {
  font-size: 42px;
  line-height: 50px;
  font-weight: 800;
  color: #000;
  text-align: start;
  margin-bottom: 0 !important;
}

.quiz-description__image img {
  margin-left: 2em;
  margin-bottom: 2em;
}

.segmentacja-image {
  max-width: 800px;
  margin: 0em auto;
}

@media screen and (max-width: 812px) {
  .header__title,
  .header__logo {
    padding: 1em;
  }
  .quiz-description__content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .quiz-description__title {
    font-size: 1.5em;
    line-height: 1.2em;
  }

  .segmentacja-image {
    max-width: none;
    width: 100%;
  }

  .quiz-description__image img {
    margin-left: 0;
    margin-bottom: 1em;
  }
}

@media screen and (max-width: 460px) {
  .header {
    padding: 1em;
  }
  .quiz-description__title {
    font-size: 20px;
    line-height: 1.2em;
    margin-bottom: 0em !important;
  }
}
</style>

<style>
.liderki-boxes {
  display: flex;
  gap: 30px;
  justify-content: center;
}
.liderki-boxes__box {
  width: 20%;
  display: flex;
  flex-direction: column;
}
.liderki-boxes__box img {
  width: 100%;
}
.liderki-boxes__box-title {
  font-weight: 800;
  font-family: Figtree, sans-serif;
  text-transform: uppercase;
}
.liderki-boxes__box .box-content {
  color: #fff;
  font-weight: 600;
  border-radius: 999px 999px 120px 120px;
  flex-grow: 1;
}
.liderki-boxes__box .box-content .text {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: .5em 1em 2em;
  line-height: 1.2;
}
.liderki-boxes__box.kreatywna-druzynowa .box-content {
  background: var(--color-kreatywna);
}
.liderki-boxes__box.niezrownana-zwyciezczyni .box-content {
  background: var(--color-niezrownana);
}
.liderki-boxes__box.kreatorka-rozwiazan .box-content {
  background: var(--color-kreatorka);
}
.liderki-boxes__box.kanapowa-menadzerka .box-content {
  background: var(--color-kanapowa);
}
.liderki-boxes__box.realizujaca-marzenia .box-content {
  background: var(--color-realizujaca);
}

@media screen and (max-width: 1280px) {
  .liderki-boxes__box-title {
    font-size: 18px;
  }
}
@media screen and (max-width: 812px) {
  .liderki-boxes {
    flex-wrap: wrap;
  }
  .liderki-boxes__box {
    width: calc( (100% / 3) - 20px );
  }
  .liderki-boxes__box-title {
    font-size: 18px;
  }
}

@media screen and (max-width: 460px) {
  .liderki-boxes__box {
    width: calc( (100% / 2) - 20px );
  }
}
</style>
